var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBadSmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 99,
    viewBox: "0 0 98 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9999 12.7502C28.7035 12.7502 12.2499 29.2037 12.2499 49.5002C12.2499 69.7966 28.7035 86.2502 48.9999 86.2502C69.2964 86.2502 85.7499 69.7966 85.7499 49.5002C85.7499 29.2037 69.2964 12.7502 48.9999 12.7502ZM4.08325 49.5002C4.08325 24.6934 24.1931 4.5835 48.9999 4.5835C73.8067 4.5835 93.9166 24.6934 93.9166 49.5002C93.9166 74.307 73.8067 94.4168 48.9999 94.4168C24.1931 94.4168 4.08325 74.307 4.08325 49.5002Z",
    fill: "#9F9978"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6034 58.4478C37.8617 56.0782 42.7707 53.5835 48.9999 53.5835C55.2292 53.5835 60.1381 56.0782 63.3964 58.4478C65.0334 59.6384 66.2988 60.8285 67.1648 61.7322C67.5995 62.1857 67.9384 62.5722 68.1778 62.8575C68.2977 63.0003 68.3931 63.1183 68.4635 63.2072L68.5504 63.3185L68.5799 63.357L68.5911 63.3718L68.5958 63.378L68.5979 63.3808C68.5989 63.3822 68.5999 63.3835 65.3941 65.7879L68.5999 63.3835C69.953 65.1876 69.5874 67.7471 67.7832 69.1002C65.9848 70.449 63.4358 70.0899 62.0794 68.3005L62.0776 68.2982L62.0604 68.2763C62.0361 68.2456 61.9899 68.1881 61.9224 68.1076C61.787 67.9463 61.5676 67.6948 61.2686 67.3827C60.6671 66.7551 59.7633 65.9036 58.593 65.0525C56.2367 63.3388 52.979 61.7502 48.9999 61.7502C45.0208 61.7502 41.7631 63.3388 39.4068 65.0525C38.2365 65.9036 37.3327 66.7551 36.7312 67.3827C36.4322 67.6948 36.2128 67.9463 36.0774 68.1076C36.0099 68.1881 35.9637 68.2456 35.9394 68.2763M32.6666 65.8335C29.3999 63.3835 29.4009 63.3822 29.4019 63.3808L29.404 63.378L29.4087 63.3718L29.4199 63.357L29.4494 63.3185L29.5363 63.2072C29.6067 63.1183 29.7021 63.0003 29.822 62.8575C30.0614 62.5722 30.4003 62.1857 30.835 61.7322C31.701 60.8285 32.9664 59.6384 34.6034 58.4478",
    fill: "#9F9978"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6667 37.2498C32.6667 34.9947 34.4949 33.1665 36.7501 33.1665H36.7909C39.0461 33.1665 40.8742 34.9947 40.8742 37.2498C40.8742 39.505 39.0461 41.3332 36.7909 41.3332H36.7501C34.4949 41.3332 32.6667 39.505 32.6667 37.2498Z",
    fill: "#9F9978"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1667 37.2498C57.1667 34.9947 58.9949 33.1665 61.2501 33.1665H61.2909C63.5461 33.1665 65.3742 34.9947 65.3742 37.2498C65.3742 39.505 63.5461 41.3332 61.2909 41.3332H61.2501C58.9949 41.3332 57.1667 39.505 57.1667 37.2498Z",
    fill: "#9F9978"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadSmail);
export default __webpack_public_path__ + "static/media/bad_smail.3220134bf74baaeb0b8bb1169a13b9da.svg";
export { ForwardRef as ReactComponent };